import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { AuthService } from './state/auth.service';

const AuthenticatedRoute = ({ component: Component, ...attrs }) => {
  const isAuthenticated = AuthService.isAuthenticated();
  const { path, isPayer } = attrs;

  let route;

  if (isAuthenticated) {
    if (path === '/payment-info' && !isPayer && isPayer !== null) {
      route = (
        <Route
          {...attrs}
          render={() => {
            return <Redirect to="licenses" />;
          }}
        />
      );
    } else {
      route = (
        <Route
          {...attrs}
          render={props => {
            return <Component {...props} isPayer={isPayer} />;
          }}
        />
      );
    }
  } else {
    if (window.location.href.endsWith('signin')) {
      route = null;
    } else {
      route = (
        <Route
          {...attrs}
          render={() => {
            return <Redirect to="/account/signin" />;
          }}
        />
      );
    }
  }

  return route;
};

export default AuthenticatedRoute;



// WEBPACK FOOTER //
// ./src/AuthenticatedRoute.js